import React, {
  Fragment,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import styled from 'styled-components';
import { Formik, FieldArray, Field } from 'formik';

import { Button } from 'merchant-portal-components';
import { Modal } from 'merchant-portal-components';
import {
  RenderSelect,
  RenderTextField,
} from '../../../../../components/FormElements/FormikElements';
import CustomSelect from '../../../../../components/Select/Select';
import { POSValueCell, ToogleFieldPOSWrapper } from '../../styles/styles';
import TextFieldPOS from '../../components/TextFieldPOS';
import ToogleFieldPOS from '../../components/ToogleFieldPOS';
import {
  Checkbox,
  TextField,
  InputAdornment,
  Collapse,
} from '@material-ui/core';
import _ from 'lodash';
import { DeleteIcon, EditIcon } from '../../../../../components/Icon';
import ChevronUpIcon from '../../../../../components/Icon/ChevronUpIcon';
import ConfirmDeleteModal from '../../../../../components/Modal/ConfirmDeleteModal';

const ModalTitle = styled.div`
  display: grid;
  grid-template-columns: 10fr 1fr;
  padding: 24px;
`;

const ButtonsWrapper = styled.div`
  padding: 20px 40px;
  box-shadow: 0 -2px 9px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: flex-end;
`;
const NewOverrideWrapper = styled.div`
  padding: 15px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ModalBody = styled.div`
  padding: 0 24px;
  overflow-y: scroll;
  height: 60vh;
`;
const NewOverrideContainer = styled.div`
  padding: 0 24px;
`;
const OverrideSection = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 8px;
`;

const ButtonDiv = styled(Button)`
  width: 100px;
  min-width: 100px;
`;

const OverrideHeaderWrapper = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
`;
const OverrideActionWrapper = styled.p`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  gap: 10px;
`;
const Title = styled.p`
  color: #191818;
  font-size: 17px;
  font-weight: 600;
  margin: 23px 0;
`;

const OfferTitle = styled.div`
  color: #191818;
  font-size: 17px;
  font-weight: 600;
  margin-top: 30px;
  margin-bottom: 15px;
`;

const VariantsDiv = styled.div`
  margin-top: 40px;
`;

const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 30px;
`;

const Header = styled.p`
  font-size: 15px;
  font-weight: 600;
`;

const BodyDiv = styled.div``;

const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 10px;
`;

const RowCol = styled.div`
  font-size: 14px;
  align-self: center;
`;

const LineDivider = styled.hr`
  border: 1px solid rgba(0, 0, 0, 0.09);
  margin: 15px 0;
`;

const POSRows = styled.div`
  display: flex;
  gap: 20px;
`;

const NoLocationSelectedDiv = styled.p`
  color: #959595;
  font-size: 20px;
  letter-spacing: 0.03;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;
export const POSWrapper = styled.div`
  height: 80px;
  margin-top: 10px;
`;

const OfferOverridesModal = ({
  isOverrideModal,
  setIsOverrideModal,
  onSubmit,
  selectedLocations,
  setSelectedLocations,
  modifiedBusinessList,
  posDiscountsMappingFields,
  selectedOfferOverride,
  overriddenBusinessIds,
  onBatchComplete,
}) => {
  const [posOverrideInitial, setPosOverrideInitial] = useState({});
  const [isAddingNewOverride, setIsAddingNewOverride] = useState(false);
  const [newOverrideValues, setNewOverrideValues] = useState({
    businessIds: [],
    discount: {},
  });
  const [searchString, setSearchString] = useState('');
  const [searchedBusinessIds, setSearchedBusinessIds] = useState(
    () => modifiedBusinessList?.map((b) => b.id) || [],
  );
  const [overrideKeyToDelete, setOverrideKeyToDelete] = useState(null);
  const [isDeletingOverride, setIsDeletingOverride] = useState(false);
  useEffect(() => {
    const categorizedOverrides =
      selectedOfferOverride?.pos_mappings?.reduce(
        (acc, mapping, currentIndex) => {
          const businessId = mapping.business_id;
          if (businessId) {
            const initialPayload = {};
            Object.keys(posDiscountsMappingFields)?.forEach((key) => {
              initialPayload[key] = mapping[key];
            });
            const foundKey = Object.keys(acc)?.find((key) =>
              _.isEqual(acc[key]?.discount, initialPayload),
            );

            if (foundKey) {
              acc[foundKey] = {
                businessIds: [
                  ...(acc[foundKey]?.businessIds || []),
                  businessId,
                ],
                discount: initialPayload,
                mapping: [...(acc[foundKey]?.mapping || []), mapping],
                isExpanded: false,
              };
            } else {
              acc[currentIndex + 1] = {
                businessIds: [businessId],
                discount: initialPayload,
                mapping: [mapping],
                isExpanded: false,
              };
            }
          }
          return acc;
        },
        {},
      ) || {};

    setPosOverrideInitial(categorizedOverrides);
  }, [
    selectedOfferOverride,
    posDiscountsMappingFields,
    modifiedBusinessList,
    selectedLocations,
  ]);

  const handleChangeNewOverride = (field, value) => {
    setNewOverrideValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmitNewOverrides = async () => {
    const { businessIds, discount } = newOverrideValues;
    const submitPayload = {
      ...discount,
      type: 'offer',
      discount_id: selectedOfferOverride.offer_id,
    };
    const posValuesToSubmit = {};
    const newOverrideIds = businessIds.filter(
      (id) => !overriddenBusinessIds.includes(id),
    );
    const currentOverrideIds = businessIds.filter((id) =>
      overriddenBusinessIds.includes(id),
    );
    if (newOverrideIds?.length > 0) {
      await onSubmit({ ...submitPayload, businessIds: newOverrideIds }, 'post');
    }
    if (currentOverrideIds?.length > 0) {
      await onSubmit(
        { ...submitPayload, businessIds: currentOverrideIds },
        'patch',
      );
    }
    if (onBatchComplete) {
      await onBatchComplete();
    }
  };
  const handleSubmitOverrides = async (selectedOverride, key) => {
    const { businessIds, discount } = selectedOverride;
    const { businessIds: initialBusinessIds, discount: initialDiscount } =
      posOverrideInitial[key];
    const submitPayload = {
      ...discount,
      type: 'offer',
      discount_id: selectedOfferOverride.offer_id,
    };
    const posValuesToSubmit = {};
    const isPOSValueEqual = _.isEqual(discount, initialDiscount);
    const newOverrideIds = businessIds.filter(
      (id) => !overriddenBusinessIds.includes(id),
    );
    const currentOverrideIds = businessIds.filter((id) =>
      overriddenBusinessIds.includes(id),
    );
    const removedOverrideIds = initialBusinessIds.filter(
      (id) => !businessIds.includes(id),
    );
    if (newOverrideIds?.length > 0) {
      await onSubmit({ ...submitPayload, businessIds: newOverrideIds }, 'post');
    }
    if (removedOverrideIds?.length > 0) {
      await onSubmit(
        { ...submitPayload, businessIds: removedOverrideIds },
        'delete',
      );
    }
    if (currentOverrideIds?.length > 0 && !isPOSValueEqual) {
      await onSubmit(
        { ...submitPayload, businessIds: currentOverrideIds },
        'patch',
      );
    }
    if (onBatchComplete) {
      await onBatchComplete();
      setNewOverrideValues({
        businessIds: [],
        discount: {},
      });
      setIsAddingNewOverride(false);
    }
  };

  const handleEditOverride = (key, setFieldValue, isExpanded) => {
    setFieldValue(`${key}.isExpanded`, !isExpanded);
  };

  const handleDeleteOverride = async (selectedOverride) => {
    if (!selectedOverride) {
      return;
    }
    const { businessIds, discount } = selectedOverride;
    const submitPayload = {
      ...discount,
      type: 'offer',
      discount_id: selectedOfferOverride.offer_id,
      businessIds,
    };

    setIsDeletingOverride(true);
    try {
      await onSubmit(submitPayload, 'delete');
      if (onBatchComplete) {
        await onBatchComplete();
      }
      setOverrideKeyToDelete(null);
    } finally {
      setIsDeletingOverride(false);
    }
  };

  const handleSearchChange = (searchString) => {
    setSearchString(searchString);
    if (searchString.trim() === '') {
      setSearchedBusinessIds(modifiedBusinessList?.map((b) => b.id) || []);
    } else {
      const filteredBusinesses = modifiedBusinessList.filter((business) =>
        business.business_name
          .toLowerCase()
          .includes(searchString.toLowerCase()),
      );
      const filteredBusinessIds = filteredBusinesses.map((b) => b.id);
      setSearchedBusinessIds(filteredBusinessIds);
    }
  };

  return (
    <Modal borderRadius>
      <div
        style={{
          width: '550px',
        }}
      >
        <ModalTitle>
          <div>Overrides for {selectedOfferOverride?.label}</div>
          <div
            onClick={() => setIsOverrideModal(false)}
            style={{ cursor: 'pointer' }}
          >
            x
          </div>
        </ModalTitle>
        <NewOverrideContainer>
          <NewOverrideWrapper>
            <TextField
              label='Search business override'
              value={searchString}
              onChange={(e) => {
                handleSearchChange(e.target.value);
              }}
              variant='outlined'
              style={{ width: '300px' }}
            />
            <ButtonDiv onClick={() => setIsAddingNewOverride(true)}>
              + New
            </ButtonDiv>
          </NewOverrideWrapper>
          {isAddingNewOverride && (
            <OverrideSection>
              <CustomSelect
                options={modifiedBusinessList || []}
                isMulti
                getOptionLabel={(business) => business.business_name}
                getOptionValue={(business) => business.id}
                placeholder='Search Locations'
                onChange={(e) => {
                  handleChangeNewOverride(
                    'businessIds',
                    e.map((option) => option.id),
                  );
                  setSelectedLocations(e);
                }}
                style={{ marginBottom: '20px' }}
              />
              <div>
                <Fragment>
                  {Object.keys(posDiscountsMappingFields)?.map((posKey) => {
                    return (
                      <POSWrapper key={`p_${posKey}`}>
                        {posDiscountsMappingFields[posKey].type === 'string' ? (
                          <TextField
                            name='pos'
                            id='outlined-basic'
                            label={posKey}
                            placeholder={
                              posDiscountsMappingFields[posKey].label
                            }
                            variant='outlined'
                            style={{ width: '100%' }}
                            onChange={(e) =>
                              handleChangeNewOverride('discount', {
                                ...newOverrideValues.discount,
                                [posKey]: e.target.value,
                              })
                            }
                            value={newOverrideValues.discount[posKey] || ''}
                          />
                        ) : (
                          <ToogleFieldPOSWrapper>
                            <ToogleFieldPOS
                              name='pos'
                              onChange={(e) =>
                                handleChangeNewOverride('discount', {
                                  ...newOverrideValues.discount,
                                  [posKey]: e.target.checked,
                                })
                              }
                              checked={
                                newOverrideValues.discount[posKey] || false
                              }
                            />
                          </ToogleFieldPOSWrapper>
                        )}
                      </POSWrapper>
                    );
                  })}
                </Fragment>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 10,
                }}
              >
                <ButtonDiv
                  secondary
                  onClick={() => setIsAddingNewOverride(false)}
                >
                  Cancel
                </ButtonDiv>
                <ButtonDiv
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmitNewOverrides();
                  }}
                >
                  Save
                </ButtonDiv>
              </div>
            </OverrideSection>
          )}
        </NewOverrideContainer>
        <Formik
          initialValues={{
            ...posOverrideInitial,
          }}
          enableReinitialize={true}
        >
          {({
            dirty,
            values,
            setFieldValue,
            initialValues,
            handleChange,
            handleSubmit,
            touched,
          }) => (
            <form>
              <ModalBody>
                {Object.keys(values).map((key, index) => (
                  <OverrideSection
                    key={values[key].businessIds.join(',')}
                    style={{
                      display: values[key].businessIds.some((id) =>
                        searchedBusinessIds.includes(id),
                      )
                        ? 'block'
                        : 'none',
                    }}
                  >
                    <OverrideHeaderWrapper>
                      <Title>Override {index + 1}</Title>
                      <OverrideActionWrapper>
                        {values[key].isExpanded ? (
                          <ChevronUpIcon
                            aria-hidden='true'
                            onClick={() =>
                              handleEditOverride(
                                key,
                                setFieldValue,
                                values[key].isExpanded,
                              )
                            }
                          />
                        ) : (
                          <EditIcon
                            aria-hidden='true'
                            onClick={() =>
                              handleEditOverride(
                                key,
                                setFieldValue,
                                values[key].isExpanded,
                              )
                            }
                          />
                        )}
                        <DeleteIcon
                          aria-hidden='true'
                          onClick={() => setOverrideKeyToDelete(key)}
                        />
                      </OverrideActionWrapper>
                    </OverrideHeaderWrapper>
                    <Field
                      name={`${key}.businessIds`}
                      component={RenderSelect}
                      options={modifiedBusinessList || []}
                      isMulti
                      getOptionLabel={(business) => business.business_name}
                      getOptionValue={(business) => business.id}
                      valueKey='id'
                      placeholder='Search Locations'
                      isDisabled={!values[key].isExpanded}
                      onChange={(e) => {
                        setSelectedLocations(e);
                        setFieldValue(
                          `${key}.businessIds`,
                          e.map((option) => option.id),
                        );
                      }}
                      simpleValue
                    />
                    <Collapse in={values[key].isExpanded}>
                      <div>
                        <Fragment key={`o_${selectedOfferOverride.id}`}>
                          {Object.keys(values[key].discount)?.map((posKey) => {
                            return (
                              <POSWrapper
                                key={`p_${selectedOfferOverride.id}_${key}_${posKey}`}
                              >
                                {posDiscountsMappingFields[posKey].type ===
                                'string' ? (
                                  <TextField
                                    name={`${key}.discount.${posKey}`}
                                    id='outlined-basic'
                                    label={posKey}
                                    placeholder={
                                      posDiscountsMappingFields[posKey].label
                                    }
                                    variant='outlined'
                                    style={{ width: '100%' }}
                                    onChange={(e) =>
                                      setFieldValue(
                                        `${key}.discount.${posKey}`,
                                        e.target.value,
                                      )
                                    }
                                    value={values[key].discount[posKey] || ''}
                                  />
                                ) : (
                                  <ToogleFieldPOSWrapper>
                                    <ToogleFieldPOS
                                      name={`${key}.discount.${posKey}`}
                                      onChange={(e) =>
                                        setFieldValue(
                                          `${key}.discount.${posKey}`,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  </ToogleFieldPOSWrapper>
                                )}
                              </POSWrapper>
                            );
                          })}
                        </Fragment>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: 10,
                        }}
                      >
                        <ButtonDiv
                          onClick={(e) => {
                            e.preventDefault();
                            handleSubmitOverrides(values[key], key);
                          }}
                        >
                          Save
                        </ButtonDiv>
                      </div>
                    </Collapse>
                  </OverrideSection>
                ))}
              </ModalBody>
              {overrideKeyToDelete && (
                <ConfirmDeleteModal
                  requestingDelete={isDeletingOverride}
                  deleteAction={() =>
                    handleDeleteOverride(values[overrideKeyToDelete])
                  }
                  cancel={() => setOverrideKeyToDelete(null)}
                />
              )}
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default OfferOverridesModal;
